<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="9">
        <!-- <b-form-input
          size="sm"
          class="mr-sm-2"
          type="text"
          placeholder="Search"
          @keyup="filterList"
          v-model="searchString"
        />-->
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i class="fa fa-times appendIcon clickIcon" @click="resetSearch"></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button class="mr-2 btn" variant="success" type="submit" size="md" @click="newCuisine">
            <i class="fa fa-address-card-o"></i>
            Add Cuisine Type
          </b-button>
        </div>
        <div>
          <StyledDialog @filterList="filterList" :CurrentObject="mySelected" EntityType="Cuisine">
            <div slot="header">
              <h2>{{mySelected.CuisineType}}</h2>
              <h4>{{mySelected.CuisineDescription}}</h4>
            </div>
            <div slot="details">
              <div></div>
            </div>
            <span slot="entityType">Cuisine Type</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>

    <b-row></b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import moment from "moment";

export default {
  name: "CuisineList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        {
          key: "CuisineType",
          label: "Cuisine",
          sortable: true,
          thStyle: "width: 30%;"
        },
        { key: "CuisineDescription", label: "Description", sortable: true }
      ],
      mySelected: { Cuisine: {} },
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: ""
    };
  },
  components: {
    cTable,
    //DeleteDialog,
    StyledDialog
  },
  created() {
    this.$store.dispatch("seminar/fetchCuisines").then(this.filterList());
    //this.filteredCampaigns = this.$store.state.campaign.campaigns;
    //this.filterList();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.seminar.cuisines.length;
      //return 4;
    },
    totalObjects: function() {
      return this.$store.state.seminar.cuisines;
      //return 4;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["seminar", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  watch: {
    totalObjects(newValue, oldValue) {
      this.filterList();
    }
  },
  methods: {
    filterList: function() {
      this.filteredObjects = this.$store.state.seminar.cuisines.filter(
        cuisine =>
          cuisine.CuisineType.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          cuisine.CuisineDescription.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    incrementCount() {
      this.$store.commit("INCREMENT_COUNT");
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    myRowClickHandler(record, index) {
      this.$store
        .dispatch("seminar/loadCuisineEdit", record.CuisineID)
        .then(() => {
          this.$router.push({ name: "Cuisine" });
        });
    },
    newCuisine() {
      this.$store
        .dispatch("seminar/newCuisine", this.createFreshObject())
        .then(() => {
          this.$router.push({ name: "Cuisine" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    deleteUser() {
      //this.$store.dispatch("n_user/createUser", this.createFreshUserObject());
    },
    createFreshObject() {
      return {
        CuisineID: -1
      };
    },
    GetEarliestMailDate() {
      switch (moment().day()) {
        // If it is Monday (1),Saturday(6), or Sunday (0), Get the previous Friday (5)
        // and ensure we are on the previous week
        case 0:
          return moment().add(5, "days");
        case 1:
          return moment().add(4, "days");
        case 2:
          return moment().add(10, "days");
        case 3:
          return moment().add(9, "days");
        case 4:
          return moment().add(8, "days");
        case 5:
          return moment().add(7, "days");
        case 6:
          return moment().add(6, "days");
        default:
          return moment().add(3, "days");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>